import { FormatNumberOptions } from 'react-intl';
import { intl } from '../intl';

export const getIntlNumber = (number: number, options?: FormatNumberOptions): string => intl.formatNumber(number, options);
